__turbopack_context__.v({
  "aside": "SellerSection-module-scss-module__1S9sCq__aside",
  "asideHeading": "SellerSection-module-scss-module__1S9sCq__asideHeading",
  "asideList": "SellerSection-module-scss-module__1S9sCq__asideList",
  "asideListLabel": "SellerSection-module-scss-module__1S9sCq__asideListLabel",
  "asideListValue": "SellerSection-module-scss-module__1S9sCq__asideListValue",
  "closed": "SellerSection-module-scss-module__1S9sCq__closed",
  "content": "SellerSection-module-scss-module__1S9sCq__content",
  "fade-in": "SellerSection-module-scss-module__1S9sCq__fade-in",
  "information": "SellerSection-module-scss-module__1S9sCq__information",
  "no-transform": "SellerSection-module-scss-module__1S9sCq__no-transform",
  "noInformationText": "SellerSection-module-scss-module__1S9sCq__noInformationText",
  "rotate": "SellerSection-module-scss-module__1S9sCq__rotate",
  "sellerSection": "SellerSection-module-scss-module__1S9sCq__sellerSection",
});
